export const IDENTITY_VALIDATION_DOCUMENT_TYPE = 'IdentityValidation';
export const OTHER_DOCUMENTS_TYPE = 'OtherDocument';
export const OFFICIAL_IDENTIFICATION_BACK_TYPE = 'OfficialIdentificationBack';
export const OFFICIAL_IDENTIFICATION_TYPE = 'OfficialIdentification';
export const RECORD_OWNER_CHANGED_DOCUMENT_TYPE = 'RecordOwnerChangedDocument';
export const RECORD_DISBURSEMENT_DELAYED_DOCUMENT_TYPE = 'RecordDisbursementDelayedDocument';
